import React, { useState, useEffect, useContext } from 'react';
import '../styles/dashboard.css';
import { UserContext } from './UserContext';

const API_BASE_URL = 'https://gnrl-bknd-server.onrender.com/api';

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fileNameFilter, setFileNameFilter] = useState('');
  const {user} = useContext(UserContext);

  // Fetch data function
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/progress/user/${user || 'all'}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      
      const result = await response.json();
      setData(Array.isArray(result) ? result : []);
      setError(null);
    } catch (err) {
      setError('Failed to fetch data. Please try again later.');
      console.error('Fetch error:', err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Initial data fetch
  useEffect(() => {
    fetchData();
  }, []);

  // Filter data
  const filteredData = data.filter(item => {
    const matchFileName = item.fileName.toLowerCase().includes(fileNameFilter.toLowerCase());
    return matchFileName;
  });

  // Calculate statistics from filtered data
  const totalPlayTime = filteredData.reduce((sum, item) => sum + (item.playTime || 0), 0);
  const totalRepeats = filteredData.reduce((sum, item) => sum + (item.repeats || 0), 0);
  const completedCount = filteredData.filter(item => item.completed).length;

  if (loading) {
    return <div className="loading-state">Loading data...</div>;
  }

  if (error) {
    return <div className="error-state">{error}</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-card">
        <div className="card-header">
          <h2>{user} Dashboard</h2>
        </div>
        <div className="card-content">
          <div className="summary-cards">
            <div className="summary-card">
              <div className="summary-value">{totalPlayTime}</div>
              <p className="summary-label">Total Play Time In Seconds</p>
            </div>
            <div className="summary-card">
              <div className="summary-value">{totalRepeats}</div>
              <p className="summary-label">Total Repeats</p>
            </div>
            <div className="summary-card">
              <div className="summary-value">{completedCount}</div>
              <p className="summary-label">Completed Items</p>
            </div>
          </div>

          <div className="filters">
            <div className="filter-group">
              <label>Filename Filter</label>
              <input
                type="text"
                placeholder="Filter by filename..."
                value={fileNameFilter}
                onChange={(e) => setFileNameFilter(e.target.value)}
              />
            </div>
          </div>

          {filteredData.length === 0 ? (
            <div className="no-data">No data found. Try adjusting your filters.</div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Filename</th>
                    <th>Play Time in Seconds</th>
                    <th>Repeats</th>
                    <th>Status</th>
                    <th>Last Updated</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item) => (
                    <tr key={item._id}>
                      <td>{item.fileName}</td>
                      <td>{item.playTime}</td>
                      <td>{item.repeats}</td>
                      <td>
                        <span className={`status-badge ${item.completed ? 'completed' : 'in-progress'}`}>
                          {item.completed ? 'Completed' : 'In Progress'}
                        </span>
                      </td>
                      <td>{new Date(item.updatedAt).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;